export default __webpack_public_path__ + "static/media/PDFINVOICEFEE.976d5b27.png";